import React, { useEffect, useState } from 'react';
import axios from '../api/axios';
import Sidebar from '../components/Sidebar';
import { CSVLink } from 'react-csv';

function SalesReport() {
  const [sales, setSales] = useState([]);
  const [filters, setFilters] = useState({ start: '', end: '' });

  useEffect(() => {
    const params = {};
    if (filters.start) params.start = filters.start;
    if (filters.end) params.end = filters.end;
    axios.get('/reports/sales', { params }).then(res => setSales(res.data));
  }, [filters]);

  const total = sales.reduce((sum, s) => sum + (parseFloat(s.total) || 0), 0);

  return (
    <div className="flex">
      
      <div className="p-6 w-full">
        <h2 className="text-2xl font-bold mb-4">Sales Report</h2>
        <div className="flex gap-2 mb-4">
          <input type="date" className="border p-2" value={filters.start} onChange={e => setFilters({ ...filters, start: e.target.value })} />
          <input type="date" className="border p-2" value={filters.end} onChange={e => setFilters({ ...filters, end: e.target.value })} />
          <CSVLink data={sales} filename="sales-report.csv" className="bg-green-600 text-white px-4 py-2 rounded">Export CSV</CSVLink>
        </div>
        <table className="table-auto w-full text-left border mb-4">
          <thead><tr><th className="p-2 border">Date</th><th className="p-2 border">Customer</th><th className="p-2 border">Total</th></tr></thead>
          <tbody>
            {sales.map(row => (
              <tr key={row.id}>
                <td className="p-2 border">{new Date(row.sale_date).toLocaleDateString()}</td>
                <td className="p-2 border">{row.customer_id}</td>
                <td className="p-2 border">${row.total}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <p className="font-bold">Total Sales: ${total?.toFixed(2)}</p>
      </div>
    </div>
  );
}
export default SalesReport;